{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "staff_holdout_opt_out",
  "title": "Staff holdout opt-out",
  "description": "Per-client setting that excludes a domain from the staff holdout slice.",
  "type": "object",
  "properties": {
    "opt_out": {
      "ui:sectionTitle": "Holdout",
      "ui:sectionDescription": "Exclude this domain from the staff holdout.",
      "ui:sectionIcon": "Shield",
      "type": "boolean",
      "default": false,
      "ui:description": "Exclude this domain from the staff holdout slice."
    }
  },
  "default": {
    "opt_out": false
  }
}
